export default {
  props: {
    /**
      * Whether component is collapsed on view
      */
    collapse: {type: Boolean, default: true},
    /**
      * Whether component is collapsable
      */
    collapsable: {type: Boolean, default: true}
  },
  data() {
    return {
      collapsed: (this.collapsable && this.collapse)
    };
  },
  methods: {
    hide() {
      this.collapsed = true;
    },
    show() {
      this.collapsed = false;
    },
    toggle() {
      this.collapsed = !this.collapsed;
    }
  }
};
